<fieldset
    class="radio-field d-flex"
    [class.flex-column]="useResponsiveLayout()"
    [class.flex-md-row]="useResponsiveLayout()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-invalid]="isInvalid()"
>
    @for (option of options(); track option.value) {
        <span class="d-flex align-items-center me-3 ps-0" [class.my-2]="useResponsiveLayout()">
            <input
                class="form-check-input radio-field-input"
                type="radio"
                [id]="optionId(option)"
                [name]="groupName()"
                [value]="option.value"
                [checked]="isSelected(option)"
                [disabled]="!editable() || !!option.disabled"
                [required]="required()"
                [class.is-valid]="isValid()"
                [class.is-invalid]="isInvalid()"
                (change)="onChange($event)"
                (blur)="touched.set(true)"
            />
            <label class="ms-2 mb-0" [for]="optionId(option)">{{ option.label }}</label>
        </span>
    }
</fieldset>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
